import React, {useState, useEffect} from "react"
// MUI
import {Box, Button, Grid2 as Grid, Stack} from "@mui/material"
import {Add, BrushOutlined, TranslateOutlined, TuneOutlined} from "@mui/icons-material"
// Layout / tokens
import {SectionCard} from "@/components/Layout"
import {packagingTokens as tk} from "@/theme/packagingTokens"
// Sections
import AppEditorGeneralSection from "@/components/Apps/AppsEditor/sections/AppEditorGeneralSection"
import AppEditorDesignSection from "@/components/Apps/AppsEditor/sections/AppEditorDesignSection"
import AppEditorTranslationsSection from "@/components/Apps/AppsEditor/sections/AppEditorTranslationsSection"
import AppEditorPreview from "@/components/Apps/AppsEditor/AppEditorPreview/AppEditorPreview"

// The app editor — a single scannable page (General · Design · Translations)
// with an always-visible sticky phone preview, replacing the old 3-tab layout.
export default function AppEditor(props: any) {

    const {app, setApp, t} = props

    // Which translation feeds the phone preview.
    const [previewTranslation, setPreviewTranslation] = useState<any>(null)
    // Translation being created/edited in the dialog (hoisted so the section
    // card's header "Add" button can open it).
    const [edition, setEdition] = useState<any>(null)

    useEffect(() => {
        if (!!app && !!app.translations && !previewTranslation) {
            let defaultTranslation = app.translations.filter((trans: any) => trans.default)
            setPreviewTranslation(defaultTranslation[0])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const handleCreateTranslation = () => {
        setEdition({
            content: {accept: "", disclaimer: "", refuse: "", title: ""},
            default: false,
            language: "en",
        })
    }

    const sectionIconSx = {fontSize: 18, color: tk.color.textTertiary}

    return (
        <>
            <Grid size={{xs: 12, md: 8}}>
                <Stack spacing={2.5}>
                    <SectionCard
                        icon={<TuneOutlined sx={sectionIconSx} />}
                        title={t("general_options")}
                        subtitle={t("general_options_subtitle")}
                    >
                        <AppEditorGeneralSection {...{app, setApp, t}} />
                    </SectionCard>

                    <SectionCard
                        icon={<BrushOutlined sx={sectionIconSx} />}
                        title={t("design")}
                        subtitle={t("design_subtitle")}
                    >
                        <AppEditorDesignSection {...{app, setApp, t}} />
                    </SectionCard>

                    <SectionCard
                        icon={<TranslateOutlined sx={sectionIconSx} />}
                        title={t("translations")}
                        subtitle={t("translations_subtitle")}
                        padded={false}
                        action={
                            <Button
                                size={"small"}
                                onClick={handleCreateTranslation}
                                startIcon={<Add sx={{fontSize: 15}} />}
                                sx={{textTransform: "none", fontSize: "12.5px", fontWeight: 600, color: tk.color.textPrimary, border: `1px solid ${tk.color.border}`, borderRadius: tk.radius.sm, px: 1.5, whiteSpace: "nowrap", flexShrink: 0, "&:hover": {backgroundColor: tk.color.bg, borderColor: tk.color.borderStrong}}}
                            >
                                {t("create_new_translation")}
                            </Button>
                        }
                    >
                        <AppEditorTranslationsSection {...{app, setApp, previewTranslation, setPreviewTranslation, edition, setEdition, t}} />
                    </SectionCard>
                </Stack>
            </Grid>

            {/* Sticky live preview */}
            <Grid size={{xs: 12, md: "auto"}}>
                <Box sx={{position: {md: "sticky"}, top: {md: 16}}}>
                    <AppEditorPreview {...{app, previewTranslation, t}} />
                </Box>
            </Grid>
        </>
    )
}
